export default "__VITE_ASSET__BtT5quV8__"